import React from 'react';
import { CONSTANT } from '../../Utils/Constant';
import TechTeam from '../../Assets/Images/pixerfect-tech-team1.avif';
import './TechPartner.scss';

const TechPartner = () => {
  return (
    <div className="tech-partner">
      <h3>Meet Our Pixel Perfectos</h3>
      <div className="tech-partner-container">
        <div className="background-gradient"></div>
        <div className="tech">
          <div className="container">
            <div className="left-img">
              <img
                src={TechTeam}
                alt={'Tech Team | ' + CONSTANT.PIXERFECT_SOLUTIONS_LLP}
                title={'Tech Team | ' + CONSTANT.PIXERFECT_SOLUTIONS_LLP}
              />
            </div>
            <div className="right-part">
              <span data-aos="fade-up" data-aos-duration="1000" data-aos-once="true">
                Tech Team
              </span>
              <p data-aos="fade-up" data-aos-duration="1200" data-aos-once="true">
                At the heart of our success is a strong team of full-stack experts and
                problem-solvers. With deep experience across modern technologies and frameworks, our
                team focuses on turning complex challenges into seamless, scalable solutions. Guided
                by visionary leaders, we build a culture of creativity, precision, and teamwork
                ensuring we don&apos;t just deliver projects, we deliver excellence that drives
                growth and inspires confidence.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechPartner;
